// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/pdf-ui/pdf-ui.less
// module id = 3858
// module chunks = 0